import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { TESTIMONIALS } from "@/lib/site";
import { Reveal } from "./Reveal";

export const Testimonials = () => {
  return (
    <section id="testimonials" data-testid="testimonials" className="py-24 lg:py-32 bg-surface">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand mb-4">06 — Testimonials</p>
              <h2 className="font-display font-extrabold text-navy tracking-tight text-4xl md:text-5xl max-w-xl leading-[1.05]">
                Loved by 150+ satisfied customers.
              </h2>
            </div>
            <div className="flex items-center gap-1 text-emerald">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-emerald" />)}
              <span className="ml-2 text-navy font-semibold text-sm">Professional · Transparent · Fast · Reliable</span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <Carousel opts={{ loop: true, align: "start" }} className="mt-14">
            <CarouselContent className="-ml-6">
              {TESTIMONIALS.map((t, i) => (
                <CarouselItem key={t.name} className="pl-6 md:basis-1/2 lg:basis-1/3">
                  <div data-testid={`testimonial-${i}`} className="h-full bg-white rounded-3xl p-8 border border-black/5 tick-shadow flex flex-col">
                    <Quote className="w-8 h-8 text-brand/20" />
                    <p className="mt-4 text-ink/70 leading-relaxed flex-1">&ldquo;{t.quote}&rdquo;</p>
                    <div className="mt-6 flex items-center gap-3 pt-5 border-t border-black/5">
                      <img src={t.img} alt={t.name} className="w-11 h-11 rounded-full object-cover" loading="lazy" />
                      <div>
                        <p className="font-display font-bold text-navy leading-none">{t.name}</p>
                        <p className="text-xs text-ink/50 mt-1">{t.role}</p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex gap-3 mt-8">
              <CarouselPrevious data-testid="testimonial-prev" className="static translate-y-0 h-11 w-11 border-black/10 text-navy hover:bg-brand hover:text-white" />
              <CarouselNext data-testid="testimonial-next" className="static translate-y-0 h-11 w-11 border-black/10 text-navy hover:bg-brand hover:text-white" />
            </div>
          </Carousel>
        </Reveal>
      </div>
    </section>
  );
};
